import React, {useCallback, useContext, useState} from "react";

export const DrawerManagerContext = React.createContext<{
    activeService: string | null;
    serviceQueue: string[],
    setServiceQueue: React.Dispatch<React.SetStateAction<string[]>>,
    setActiveService: React.Dispatch<React.SetStateAction<string | null>>,
    completeService: () => void
    open: boolean
    onOpenChange: (open: boolean) => void;
    serviceData: Record<string, any>;
    setServiceData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
    openServiceWithData: (serviceName: string, data?: any) => void;
} | null>(null);

export const DrawerManagerProvider = ({children}: { children: any }) => {
    const [activeService, setActiveService] = useState<string | null>(null);
    const [serviceQueue, setServiceQueue] = useState<string[]>([]);
    const [serviceData, setServiceData] = useState<Record<string, any>>({});

    const onOpenChange = useCallback((isOpen: boolean) => {
        if (!isOpen) {
            completeService();
        }
    }, [serviceQueue]);

    const completeService = () => {
        if (serviceQueue.length > 0) {
            const next = serviceQueue[0];
            setServiceQueue(prev => prev.slice(1));
            setActiveService(next);
            setServiceData(prevState => ({...prevState, [next]: undefined}))
        } else {
            setActiveService(null);
            setServiceData({});
        }
    };
    const openServiceWithData = useCallback((serviceName: string, data?: any) => {
        setServiceData(prev => ({
            ...prev,
            [serviceName]: data
        }));
        setActiveService(serviceName);
    }, []);

    return (
        <DrawerManagerContext.Provider value={{
            activeService,
            setActiveService,
            serviceQueue, completeService, setServiceQueue,
            open: !!activeService, onOpenChange,
            serviceData,
            setServiceData,
            openServiceWithData
        }}>
            {children}
        </DrawerManagerContext.Provider>
    )
}

export const useDrawer = () => {
    const context = useContext(DrawerManagerContext);
    if (!context) throw new Error("useDrawer must be used within DrawerProvider");
    return context;
};